import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/globalSearch'

store.injectStore()
export { store }

export const useGlobalSearchSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useGlobalSearchActions = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)
